/*
 * Reset FAQ — animated accordion.
 *
 * Native <details>/<summary> has no built-in open/close animation and the
 * markup already relies on the `name` attribute for native exclusive-group
 * behaviour (only one open at a time, unless "Allow several answers open at
 * once" is on). To animate the height we have to intercept the click and
 * drive it ourselves — which also means re-implementing that same-group
 * exclusivity in JS, since preventDefault() stops the native toggle (and
 * with it, the browser's own group handling) from ever running.
 *
 * Skips itself entirely — leaving the plain, instant, but still fully
 * correct native accordion — when the browser lacks Web Animations, or the
 * visitor has asked for reduced motion.
 */
(function () {
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var items = document.querySelectorAll('.reset-faq__item');
  if (!items.length || prefersReduced || !items[0].animate) return;

  var EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var EASE_IN = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function Accordion(el) {
    this.el = el;
    this.summary = el.querySelector(':scope > summary');
    this.content = el.querySelector(':scope > .reset-faq__a');
    this.group = el.getAttribute('name');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    el.faqAccordion = this;
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  Accordion.prototype.onClick = function (event) {
    event.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  };

  Accordion.prototype.open = function () {
    if (this.group) {
      var siblings = document.querySelectorAll('[name="' + this.group + '"][open]');
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] !== this.el && siblings[i].faqAccordion) {
          siblings[i].faqAccordion.shrink();
        }
      }
    }
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  Accordion.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 320, easing: EASE_OUT }
    );
    this.animation.onfinish = this.onFinish.bind(this, true);
    this.animation.oncancel = function () {
      this.isExpanding = false;
    }.bind(this);
  };

  Accordion.prototype.shrink = function () {
    this.isClosing = true;
    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 260, easing: EASE_IN }
    );
    this.animation.onfinish = this.onFinish.bind(this, false);
    this.animation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);
  };

  Accordion.prototype.onFinish = function (open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  items.forEach(function (el) {
    new Accordion(el);
  });
})();
